import { labelStyles } from 'components/MainComponent/LabelStyles'
import { TamediaLink } from 'components/TamediaLink'
import { ReadDataFromWindow } from 'components/WindowCommunication'
import { useLabels } from 'Hooks/useLabels'
import { useState } from 'react'

export const Part6 = ({
  tenant,
  colorMode,
}: {
  tenant: Tenant | undefined
  colorMode: 'light' | 'dark' | undefined
}) => {
  const [userinputs, setUserInputs] = useState<UserInputsType>({})

  const Labels = useLabels(labelStyles)
  function handleNewData(data: dbDataType) {
    if (data && data.userinputs && data.userinputs.weight)
      setUserInputs(data.userinputs)
  }
  return (
    <>
      <ReadDataFromWindow callback={handleNewData} />
      {userinputs.weight &&
        (tenant?.lang === 'de' ? (
          <>
            <p>
              <Labels userRelation>
                {' '}
                Die meisten Kaffeeliebhaber,{' '}
                {!!((userinputs.caffeine || 0) < (userinputs.health || 0)) && (
                  <>Sie inklusive,</>
                )}{' '}
                trinken aber ohnehin in einem Mass, das für die Gesundheit
                unbedenklich ist.
              </Labels>{' '}
              Im Gegenteil dürfte ein solcher Konsum sogar positive Effekte
              haben: Neurowissenschaftler der amerikanischen{' '}
              <TamediaLink href='https://hub.jhu.edu/2014/01/12/caffeine-enhances-memory/#:~:text=Now%2C%20researchers%20at%20Johns%20Hopkins,on%20our%20long%2Dterm%20memory'>
                Johns Hopkins University
              </TamediaLink>{' '}
              haben herausgefunden, dass Koffein das Gedächtnis bis zu 24
              Stunden nach dem Kaffeetrinken verbessern kann und damit auch
              einen positiven Effekt auf das Langzeitgedächtnis hat. Und laut
              dem{' '}
              <TamediaLink href='https://www.dife.de/news/archiv/details-archiv/gene-beeinflussen-wie-stark-kaffee-vor-diabetes-schuetzt-75/'>
                Deutschen Institut für Ernährungsforschung
              </TamediaLink>{' '}
              deutet vieles darauf hin, dass Kaffeetrinken das Diabetesrisiko
              reduziert.
            </p>
          </>
        ) : (
          <p>
            <Labels userRelation>
              {' '}
              La plupart des amateurs de café,{' '}
              {!!((userinputs.caffeine || 0) < (userinputs.health || 0)) && (
                <>vous y compris,</>
              )}{' '}
              en boivent dans des proportions qui ne sont pas dangereuses pour
              la santé.
            </Labels>{' '}
            Au contraire, une telle consommation devrait même avoir des effets
            positifs: des neuroscientifiques de{' '}
            <TamediaLink href='https://hub.jhu.edu/2014/01/12/caffeine-enhances-memory/#:~:text=Now%2C%20researchers%20at%20Johns%20Hopkins,on%20our%20long%2Dterm%20memory'>
              l'Université Johns Hopkins
            </TamediaLink>
            , aux États-Unis, ont découvert que la caféine peut améliorer la
            mémoire jusqu'à vingt-quatre heures après avoir bu du café et
            qu'elle a donc également un effet positif sur la mémoire à long
            terme. Et selon{' '}
            <TamediaLink href='https://www.dife.de/news/archiv/details-archiv/gene-beeinflussen-wie-stark-kaffee-vor-diabetes-schuetzt-75/'>
              l'Institut allemand de recherche en nutrition
            </TamediaLink>
            , de nombreux éléments indiquent que boire du café réduit le risque
            de diabète.
          </p>
        ))}
    </>
  )
}
